/**
 * PHFIntro
 *
 * Simple left-aligned text section on a white background.
 * Used to introduce the emotional context or purpose of the page.
 *
 * Props:
 * - title (string, required): Section heading in navy
 * - body (string, required): First paragraph body text in navy
 * - body2 (string, optional): Second paragraph body text in navy
 */
const PHFIntro = ({ title, body, body2 }) => {
  return (
    <div className="bg-white py-24 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="max-w-2xl">
          <h2 className="!text-[36px] font-bold text-blue-navy font-poppins text-left leading-tight mb-8">
            {title}
          </h2>
          <p className="text-[16px] text-blue-navy text-left leading-relaxed">
            {body}
          </p>
          {body2 && (
            <p className="text-[16px] text-blue-navy text-left leading-relaxed mt-6 font-semibold">
              {body2}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PHFIntro;
